import { FC } from "react";

interface IProps {
  photo: string;
  name: string;
  role: string;
  bio: string;
}

export const TeamMemberCard: FC<IProps> = ({ photo, name, role, bio }) => (
  <div className="landing-team-page__card">
    <img src={photo} alt={name} className="landing-team-page__card-photo" />
    <h3 className="landing-team-page__card-name">{name}</h3>
    <p className="landing-team-page__card-role">{role}</p>
    <p className="landing-team-page__card-bio">{bio}</p>
  </div>
);
